import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { IntlContext, IntlProvider as IntlProvider$1 } from 'react-intl';

var IntlManager = /*#__PURE__*/function () {
  function IntlManager() {
    _classCallCheck(this, IntlManager);
    this.locales = [];
  }
  return _createClass(IntlManager, [{
    key: "addLocale",
    value: function addLocale(locale, messages) {
      var replace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var currentLocale = this.getLocale(locale);
      this.locales = [].concat(_toConsumableArray(currentLocale !== null ? this.locales.filter(function (it) {
        return it.locale !== locale;
      }) : this.locales), [{
        locale: locale,
        messages: currentLocale !== null && !replace ? _objectSpread(_objectSpread({}, currentLocale.messages), messages) : messages
      }]);
    }
  }, {
    key: "getLocale",
    value: function getLocale(locale) {
      return this.locales.find(function (it) {
        return it.locale === locale;
      }) || null;
    }
  }, {
    key: "hasLocale",
    value: function hasLocale(locale) {
      return this.getLocale(locale) !== null;
    }
  }, {
    key: "getMessages",
    value: function getMessages(locale) {
      var localeObj = this.locales.find(function (it) {
        return it.locale === locale;
      }) || null;
      if (localeObj === null) {
        return null;
      }
      return localeObj.messages;
    }
  }]);
}();

var intlManager = new IntlManager();

var defaultLocales = ['en', 'fr'];
var LocalesContext = /*#__PURE__*/React.createContext(defaultLocales);
var useLocales = function useLocales() {
  return useContext(LocalesContext);
};
var useOtherLocales = function useOtherLocales() {
  var locales = useLocales();
  var _useContext = useContext(IntlContext),
    locale = _useContext.locale;
  var otherLocales = useMemo(function () {
    return locales.filter(function (it) {
      return it !== locale;
    });
  }, [locales, locale]);
  return otherLocales;
};
var propTypes = {
  intlManager: PropTypes.instanceOf(IntlManager),
  locale: PropTypes.string,
  locales: PropTypes.arrayOf(PropTypes.string),
  extraMessages: PropTypes.objectOf(PropTypes.string),
  children: PropTypes.node
};
var defaultProps = {
  intlManager: intlManager,
  locale: null,
  locales: null,
  extraMessages: null,
  children: null
};
var IntlProvider = function IntlProvider(_ref) {
  var intlManager = _ref.intlManager,
    locale = _ref.locale,
    locales = _ref.locales,
    children = _ref.children,
    extraMessages = _ref.extraMessages;
  var previousLocales = useLocales();
  var _ref2 = useContext(IntlContext) || {},
    _ref2$locale = _ref2.locale,
    previousLocale = _ref2$locale === void 0 ? null : _ref2$locale,
    _ref2$messages = _ref2.messages,
    previousMessages = _ref2$messages === void 0 ? null : _ref2$messages;
  var messages = useMemo(function () {
    var currentMessages = intlManager.getMessages(locale);
    return _objectSpread(_objectSpread(_objectSpread({}, currentMessages), extraMessages), previousLocale === locale ? previousMessages : null);
  }, [locale, previousLocale, previousMessages, extraMessages]);
  return /*#__PURE__*/React.createElement(IntlProvider$1, {
    locale: locale,
    messages: messages
  }, /*#__PURE__*/React.createElement(LocalesContext.Provider, {
    value: locales || previousLocales
  }, children));
};
IntlProvider.propTypes = propTypes;
IntlProvider.defaultProps = defaultProps;

export { IntlManager, IntlProvider, LocalesContext, intlManager as default, useLocales, useOtherLocales };
